import FormikHomeAssumptionsAxaOwnLivePage from './FormikHomeAssumptionsAxaOwnLivePage';

export default FormikHomeAssumptionsAxaOwnLivePage;
